let _injectedProcessId = null;

const _readProcessIdFromUrl = () => {
  if (typeof window === 'undefined' || !window.location) return null;
  try {
    const value = new URLSearchParams(window.location.search || '').get('id');
    return value || null;
  } catch {
    return null;
  }
};

export const setInjectedProcessId = (processId) => {
  _injectedProcessId = processId || null;
};

export const getProcessId = () => _readProcessIdFromUrl() || _injectedProcessId;

export const __resetInjectedProcessId = () => {
  _injectedProcessId = null;
};
